import { Box, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { styled } from 'theme';
import React from 'react';

interface HelpContainerProps {
    sx?: SxProps<Theme>;
    children: React.ReactNode;
}

export const HelpContainer: React.FC<HelpContainerProps> = ({ sx, children }) => (
    <CustomBox
        sx={{
            ...sx,
        }}
    >
        {children}
    </CustomBox>
);

const CustomBox = styled(Box)(({ theme }: { theme: Theme }) => ({
    position: 'fixed',
    bottom: '16px',
    right: '16px',
    maxWidth: '90%',
    width: `${theme.breakpoints.values.sm - 4 * theme.preferredSpace}px`,
    backgroundColor: 'rgba(255,255,255, 1)',
    zIndex: theme.zIndex.appBar + 2,
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.preferredSpace * 2}px`,
    boxShadow: theme.shadows[3],
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
        maxWidth: `calc(100% - ${theme.preferredSpace * 6}px)`,
    },
}));
